import { render, staticRenderFns } from "./entity-settings-loading.vue?vue&type=template&id=ef1f1dfc&"
import script from "./entity-settings-loading.vue?vue&type=script&lang=ts&"
export * from "./entity-settings-loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports